export const homeUrl = '/'
export const howItWorksUrl = '/faq'
export const inSessionUrl = '/dispatching'
export const gamesUrl = '/games'
export const lobbyUrl = '/lobbies'
export const fortniteUrl = '/fortnite'
export const leaderboardUrl = '/fortnite/leaderboard'
export const plansUrl = '/plans'
